// ES lang
export default {
    username: "Nombre de usuario",

    //   last_name: 'Nombres',
    password: 'Contraseña',
    "Enter password": "Ingresa contraseña",
    repeat_password: 'Repetir contraseña',
    email_or_username: 'Usuario',
    email: 'Correo electrónico',
    name: 'Nombre',
    first_name: 'Nombres',
    last_name: 'Apellidos',
    gender: 'Género',
    birth_date: 'Fecha de nacimiento',
    document_type: 'Tipo de documento',
    document_number: 'Número de documento',
    institute: 'Institución',
    position: 'Cargo',
    loading: 'Cargando',
    login: 'Iniciar sesión',
    copyright: 'Todos los derechos reservados',
    optional: 'Opcional',
    description: 'Descripción',
    nit: 'NIT',
    category: 'Categoría',
    age_range: 'Rango de edad',
    third_parties: 'Cliente',
    delete: 'Eliminar',
    submit: 'Enviar',
    save: 'Guardar',
    cancel: 'Cancelar',
    icon: 'Ícono',
    order: 'Orden',
    subject: 'Asunto',
    body: 'Cuerpo',
    edit: 'Editar',
    actions: 'Acciones',
    city: 'Ciudad',
    amount: 'Valor',
    approved: 'Aprobado',
    periodicity_generation: "Periodo de generación",
    antiquity_condition: "Condición de antiguedad",
    time_to_claim: "Tiempo para reclamar",
    ejecution_date: "Tiempo de ejecución",
    blood_type: 'Tipo de Sangre',
    type_coupon_string: "Tipo de Bono",
    place: 'Nombre del lugar',
    registration_form: 'Formulario de registro',
    sign_up: 'Registrar',
    successful_registration: 'Perfil creado satisfactoriamente',
    approve: "Aprobar",
    Approve: "Aprobar",
    Inactive: "Rechazar",
    are_sure_delete: "Seguro que quieres eliminar",
    coupon: "Bono",
    time_to_ejecution: "Periodicidad de revisión de la tarea",
    "Logout": "Salir",
    forms: {
        correct_form_errors: 'Errores'
    },
    validation: {
        alpha: "El campo solo debe contener letras",
        alpha_dash: "El campo solo debe contener letras, números y guiones",
        alpha_num: "El campo solo debe contener letras y números",
        alpha_spaces: "El campo solo debe contener letras y espacios",
        between: "El campo debe estar entre {min} y {max}",
        confirmed: "El campo no coincide",
        digits: "El campo debe ser numérico y contener exactamente {length} dígitos",
        dimensions: "El campo debe ser de {width} píxeles por {height} píxeles",
        email: "El campo debe ser un correo electrónico válido",
        excluded: "El campo debe ser un valor válido",
        ext: "El campo debe ser un archivo válido",
        image: "El campo debe ser una imagen",
        integer: "El campo debe ser un entero",
        length: "El largo del campo debe ser {length}",
        max: "El campo no debe ser mayor a {length} caracteres",
        maxValue: "El campo debe de ser {max} o menor",
        mimes: "El campo debe ser un tipo de archivo válido",
        min: "El campo debe tener al menos {length} caracteres",
        min_value: "El campo debe ser {min} o superior",
        max_value: "El campo debe ser {max} o inferior",
        maxLength: "El campo debe ser {max} o inferior",
        numeric: "El campo debe contener solo caracteres numéricos",
        oneOf: "El campo debe ser un valor válido",
        regex: "El formato del campo no es válido",
        required: "El campo es obligatorio",
        required_if: "El campo  es obligatorio",
        size: "El campo debe ser menor a {size}KB",
        sameAsPassword: "Las contraseñas deben ser idénticas",
        minLength: "El campo debe ser {min} o superior",
        fill_the_required_fields: 'Complete los campos requeridos'
    },
    expired_session: 'Tu sesión ha expirado, inicia sesión nuevamente',
    login_required: 'Sesión finalizada',
    login_section: {
        init_msg: "Ingresa nombre de usuario y contraseña para acceder al sitio.",
        forgot_your_password: "¿Olvidaste tu contraseña?",
        dont_have_an_account: "¿No tienes una cuenta?",
        sign_up: "Regístrate"
    },
    company_info_section: {
        company_name: 'Nombre de la compañía',
        phone_number: 'Número de teléfono',
        primary_color: 'Color primario',
        whatsapp_number: 'Whatsapp',
        contact_email: 'Email de contacto',
        support_email: 'Email de soporte',
        instagram_name: 'Nombre usuario Instagram',
        instagram_url: 'URL Instagram',
        facebook_name: 'Nombre Facebook',
        facebook_url: 'URL Facebook',
        site_url_back: 'URL sitio (back)',
        site_url_front: 'URL sitio (front)',
    },
    projects: {
        page_title: 'Proyectos',
        name: {
            name: 'Nombre proyecto'
        },
        comments: {
            name: 'Comentarios'
        }
    },
    datatable: {
        recordsperpage: 'Registros por página',
        filter: 'Filtro',
        typetosearch: 'Buscar',
        clear: 'Limpiar',
        loading: 'Cargando',
        showing: 'Mostrando',
        of: 'de',
        totalrows: 'registros totales'
    },
    calendar: {
        days: {
            Mon: 'Lun',
            Tue: 'Mar',
            Wed: 'Mié',
            Thu: 'Jue',
            Fri: 'Vie',
            Sat: 'Sáb',
            Sun: 'Dom',
            Monday: 'Lunes',
            Tuesday: 'Martes',
            Wednesday: 'Miércoles',
            Thursday: 'Jueves',
            Friday: 'Viernes',
            Saturday: 'Sábado',
            Sunday: 'Domingo'
        },
        months: {
            January: 'Enero',
            February: 'Febrero',
            March: 'Marzo',
            April: 'Abril',
            May: 'Mayo',
            June: 'Junio',
            July: 'Julio',
            August: 'Agosto',
            September: 'Septiembre',
            October: 'Octubre',
            November: 'Noviembre',
            December: 'Diciembre'
        }
    },

    // Start - EuroCoupons
    coupon: 'Bono',
    coupons: 'Bonos',
    expiration_date: 'Fecha de Expiración',
    redemption_date: 'Fecha de canjeo',
    redeemed_by: 'Canjeado por',
    request: 'Solicitud',
    value: 'Valor',
    code: 'Código',
    state: 'Estado',
    expiration_date_help_text: 'Fecha de Expiración',
    redemption_date_help_text: 'Fecha de canjeo',
    redeemed_by_help_text: 'Canjeado por',
    request_help_text: 'Solicitud de Bono',
    value_help_text: 'Valor',
    code_help_text: 'Código',
    state_help_text: 'Estado',
    request_cardholders: 'Solicitud de Tarjetahabientes',
    request_template: 'Solicitud de Plantilla',
    request_: 'Solicitud de Plantilla',
    request_coupon: 'Solicitud de Bono',
    requests_coupons: 'Solicitudes de Bonos',
    requesting_user: 'Solicitado por',
    quantity: 'Cantidad',
    value: 'Valor',
    cxc: 'Cxc',
    requesting_user_help_text: 'Requesting user',
    quantity_help_text: 'Cantidad',
    value_help_text: 'Valor',
    cxc_help_text: 'cxc',
    thirdparty: 'Aliado',
    name: 'Nombre',
    nit: 'NIT',
    contact_name: 'Nombre del contacto',
    contact_email: 'Email principal del contacto',
    payment_due_date: 'Fecha de corte',
    prefix_code: 'Prefijo para bonos',
    logo: 'Logo',
    nit_help_text: 'NIT',
    contact_name_help_text: 'Nombre del contacto',
    contact_email_help_text: 'Email Principal del Contact',
    payment_due_date_help_text: 'Fecha de corte',
    prefix_code_help_text: 'Prefijo para bonos',
    logo_help_text: 'Logo',
    OC: 'Orden de Compra',
    request_date: 'Fecha de Solicitud',
    actions: 'Acciones',
    filters: 'Filtros',
    user: 'Usuario',
    detail: 'Detalle',
    beneficiary: 'Beneficiario',
    date: 'Fecha',
    cash_register: 'Caja',
    casher_register: 'Codigo Cajero',
    selectedRejection: 'selectedRejection',
    operation_center: 'Centro de Operaciones',
    detail_of: 'Detalle de',
    cash_register_document: 'Documento del cajero',
    invoice: 'Factura',
    reason: 'Motivo',
    location: 'Ubicación',
    select: 'Seleccionar',
    deselect: 'Quitar Selección',
    select_option: 'Seleccionar una Opción',
    redeemed: 'Redimido',
    valid: 'Válido',
    partial_redeemed: 'Redemido parcialmente',
    sent_failed: 'Envío Fallido',
    revision: 'Revisión',
    confirm: 'Confirmar',
    expired: 'Expirado',
    invalid: 'Inválido',
    invalid_document: 'Documento Inválido',
    issue: 'Novedad',
    contact: 'Contacto',
    home: 'Inicio',
    payment_method: 'Método de pago',
    validity: 'Vigencia',
    redemption_information: 'Información de Canjeo',
    users: 'Usuarios',
    update: 'Actualizar',
    document: 'Documento',
    permission_count: 'Cantidad de Permisos',
    users_count: 'Cantidad de Usuarios',
    permissions: 'Permisos',
    member_of: 'Miembros',
    group: 'Grupo',
    groups: 'Grupos',
    management: 'Administración',
    new: 'Nuevo',
    active: 'Activo',
    password_change: 'Cambiar contraseña',
    thirdparties: 'Aliados',
    autogenerate_coupons: 'Generación Automática de bonos',
    request_by: 'Solicitado por',
    total_amount: 'Monto Total',
    purchase_order: 'Orden de Compra',
    unit_value: 'Valor Unitario',
    total: 'Total',
    new_item: 'Nuevo Item',
    create: 'Crear',
    reload: 'Recargar',
    add: 'Agregar',
    upload_data_from_file: 'Cargar datos desde la plantilla',
    download_template: 'Descargar plantilla',
    process_file: 'Procesar archivo',
    valid_from: 'Inicio de Vigencia',
    select_file: 'Seleccionar archivo',
    search: 'Buscar',
    agreement: 'Convenio',
    time: 'Hora',
    items_detail: 'Detalle de los items',
    are_sure_delete: '¿Esta seguro de eliminar',
    inactive: 'Inactivo',
    nullified: 'Anulado',
    invoiced_amount: 'Valor Facturado',
    barcode: 'Código Payless',
    payless_amount: 'Valor Payless',
    type: 'Tipo',
    request_coupons: 'Solicitud de Bonos',
    edit: 'Editar',
    bin: 'Bin',
    named: 'llamado',
    superuser: 'Super Usuario (Admon)',
    is_superuser: '¿Es super Usuario?',
    is_active: '¿Esta activo?',
    is_api_user: '¿Es usuario API?',
    sections: 'Secciones',
    allowed: 'Permitidas',
    press_enter_to_select: 'Seleccionar',
    press_enter_to_remove: 'Remover',
    select_option: 'Seleccione una opción',
    permission_type: 'Tipo de permiso',
    permission: 'Permiso',
    selected: 'Seleccionado',
    permission_required: 'Permiso requerido',
    admin_required: 'Debe ser Administrador',
    path: 'Ruta',
    section: 'Sección',
    icon: 'Icono',
    hover_text: 'Texto flotante',
    company_information: 'Información de la Compañía',
    main_information: 'Información Principal',
    main_logo: 'Logo principal',
    short_logo: 'Logo pequeño',
    dark_logo: 'Logo oscuro',
    short_dark_logo: 'Logo oscuro pequeño',
    upload_image: 'Cargar imagen',
    browse: 'Explorar',
    open_color_picker: 'Abrir paleta de colores',
    issues: 'Novedades',
    fill_the_required_fields: 'Complete los campos requeridos',
    updated: 'Actualizado',
    correctly: 'Correctamente',
    success: 'Satisfactorio',
    created: 'Creado',
    deleted: 'Eliminado',
    sent: 'Enviada',
    saving: 'Guardando',
    euro_employee: 'Empleado euro',
    tableHeaders: {
        sku: 'SKU',
        ean: 'EAN',
        name: 'Nombre',
        supplier: 'Proveedor',
        nit_supplier: 'NIT del Proveedor',
        sku_supplier: 'SKU del Proveedor',
        ean_supplier: 'EAN del Proveedor',
        name_supplier: 'Nombre del Proveedor',
        is_homologated: 'Homologado'
    },
    labels: {
        templateVariables: {
            $amount: "Valor",
            $antiquity_condition_days: "Condición de antiguedad (días)",
            $antiquity_condition_months: "Condición de antiguedad (meses)",
            $antiquity_condition_years: "Condición de antiguedad (años)",
            $periodicity_generation_years: "Periodicidad de generación (años)",
            $periodicity_generation_months: "Periodicidad de generación (meses)",
            $periodicity_generation_days: "Periodicidad de generación (días)",
            $time_to_claim_days: "Tiempo para reclamar (días)",
            $time_to_claim_months: "Tiempo para reclamar (meses)",
            $time_to_claim_years: "Tiempo para reclamar (años)",
            $init_ejecution_task_date: "Inicio tarea programada del bono",
            $end_ejecution_task_date: "Fin tarea programada del bono",
            $name: "Nombre",
            $time_to_ejecution_months: "Periocidad de consulta (meses)",
            $time_to_ejecution_weeks: "Periocidad de consulta (semanas)"

        }
    },
    type_coupon: "Tipo de Bono"
    // End -  EuroCoupons
}